module.exports = __webpack_public_path__ + "media/logos/esquire-logo-5f6c321a.png";